"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Facebook = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C16.9705664,3 21,7.02943359 21,12 C21,16.4921602 17.7088301,20.2154883 13.40625,20.8906641 L13.40625,14.6015625 L15.5033203,14.6015625 L15.9023438,12 L13.40625,12 L13.40625,10.3117441 C13.40625,9.60000586 13.7549121,8.90625 14.8729336,8.90625 L16.0078125,8.90625 L16.0078125,6.69140625 C16.0078125,6.69140625 14.9778574,6.515625 13.9931836,6.515625 C11.9373867,6.515625 10.59375,7.7615625 10.59375,10.0171875 L10.59375,12 L8.30859375,12 L8.30859375,14.6015625 L10.59375,14.6015625 L10.59375,20.8906641 C6.29116992,20.2154883 3,16.4921602 3,12 C3,7.02943359 7.02943359,3 12,3 Z" })));
};
Facebook.displayName = 'Facebook';
exports.default = Facebook;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Facebook.js.map